import type { FC, ReactNode } from 'react'
import type { NeonAccent } from '@/constants/landing'

import { cn } from '@/lib/utils'
import { ACCENT_STYLES } from '@/constants/landing'

interface SectionHeadingProps {
    id: string
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    accent?: NeonAccent
    className?: string
}

const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    align = 'left',
    accent = 'cyan',
    className
}): ReactNode => {
    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            <p className={cn('font-mono text-xs font-semibold uppercase tracking-[0.28em]', ACCENT_STYLES[accent].text)}>
                {eyebrow}
            </p>

            <h2 id={id} className='mt-4 font-heading text-3xl font-semibold leading-[1.12] tracking-tight text-balance sm:text-4xl lg:text-[2.6rem]'>
                {title}
            </h2>

            {description && (
                <p className='mt-5 text-base leading-relaxed text-pretty text-muted-foreground sm:text-lg'>
                    {description}
                </p>
            )}
        </div>
    )
}

export default SectionHeading
